import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 2.05v9.95a1 1 0 0 0 1 1h9.95a10 10 0 0 1 -19.95 -1l.005 -.324a10 10 0 0 1 8.995 -9.626m6 1.29a10 10 0 0 1 4.95 7.66h-8.95v-8.95a10 10 0 0 1 4 1.29","key":"svg-0"}]]

const IconChartPie2Filled = createReactComponent('filled', 'chart-pie-2-filled', 'ChartPie2Filled', __iconNode);

export default IconChartPie2Filled;